import {
	Component,
	ElementRef,
	Input,
	OnInit
} from '@angular/core';

import styles from './VbGridList.module.less';

/**
* Generates a flex-based grid based on a supplied configuration.
* Features include:
* - configurable field types (plain text, icon, thumbnail)
* - multiple selection through a checkbox column (row is clickable)
* - optional header
*
* Features coming soon:
* - Interactive column sorting
* - Filtering
* - Single item selection
* - Dynamic field visibility
* - Tile view
* - Infinite scroll
* - Item action menu
*
* <vb-grid-list
* 		empty-msg = a message to display when the items model is empty.
* >
*		<vb-grid-list-row ng-repeat="item in items">
*
*			<header>
*				<div> header content</div>
*				<vb-grid-list-selection-header
					ng-model="$ctrl.isSelectAll"
					collection="$ctrl.webExRecordings" //collection to toggle item selection
					ng-change="<<method>>">  //fires when ng-model changes..
				</vb-grid-list-selection-header>
* 			</header>
*
*			<vb-grid-list-column
*				flex="1" // flex setting for the column
*				align="center" //align setting
*			>
*				{{content...}}
*			</vb-grid-column>
*
*
* 			<vb-grid-list-reorder // will show the arrow mark to move row up and down..
				flex="40px"
				on-item-move="$ctrl.onItemReorder($event.isUp, $index)"> //fires when up or down icon clicks
			</vb-grid-list-reorder>
*
* 			<vb-grid-list-selection-column
				ng-model="recording.selected">
			</vb-grid-list-selection-column>
*
*			<vb-grid-column	vb-grid-toolbar-column> //toolbar column
*				<a>link</a>
*				<button></button>
*			</vb-grid-column>
*
*		</columns>
* </vb-grid-list>
*/

@Component({
	selector: 'vb-grid-list',
	template: `
		<section>
			<ng-content select="[header]"></ng-content>
		</section>
		<section
			[hidden]="!isRowExists">
			<ng-content select="[vbGridRowCollection]"></ng-content>
		</section>
		<div [hidden]="isRowExists"
			[ngClass]="styles.emptyMsg">
			{{emptyMsg}}
		</div>
	`
})
export class VbGridListComponent implements OnInit {
	@Input() public emptyMsg: string;
	public readonly styles = styles;

	constructor(
		private el: ElementRef<HTMLElement>
	) {}

	public isSelectAll: boolean;

	public ngOnInit(): void {
		this.el.nativeElement.classList.add(this.styles.gridList);
	}

	public get isRowExists(): boolean {
		return !!this.el.nativeElement.getElementsByTagName('vb-grid-list-row').length;
	}
}
